import { useCallback, useEffect, useState } from 'react';
import {
  getDeferredInstallPrompt,
  isRunningStandalone,
  subscribeInstallPrompt,
} from '@/utils/pwaInstall';

export function usePwaInstallPrompt() {
  const [prompt, setPrompt] = useState(getDeferredInstallPrompt);

  useEffect(() => {
    return subscribeInstallPrompt(() => setPrompt(getDeferredInstallPrompt()));
  }, []);

  const canInstall = Boolean(prompt) && !isRunningStandalone();

  const install = useCallback(async () => {
    if (!prompt) return false;
    await prompt.prompt();
    const choice = await prompt.userChoice;
    return choice.outcome === 'accepted';
  }, [prompt]);

  return { canInstall, install };
}
